import { action, observable } from 'mobx';

import { ApiUrls } from '@app/AppConstants';

import ApiService from '@app/Services/ApiService';
import { ConnectedClientModel } from '@app/Models';

class SignalRUserStore {
    @observable users: ConnectedClientModel[] = [];

    @action
    load = () => {
        const jobData = ApiService.getTypedData<ConnectedClientModel[]>(ApiUrls.SignalRUserUrl, null);
        jobData.then((response) => { this.users = response.data || []; });
    };
}

export const signalRUserStore = new SignalRUserStore();
